import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { VirtualScrollerModule } from '@iharbeck/ngx-virtual-scroller';
import {
  CdkVirtualScrollRendererComponent,
  ItemsRendererComponent,
  VirtualScrollRendererComponent
} from './components';
import { VirtualScrollItemModule } from './components/virtual-scroll-item/virtual-scroll-item.module';
import { RenderingV2Module } from './rendering-v2.module';

@NgModule({
  imports: [CommonModule, VirtualScrollerModule, VirtualScrollItemModule, ScrollingModule, RenderingV2Module],
  declarations: [
    VirtualScrollRendererComponent,
    ItemsRendererComponent,
    CdkVirtualScrollRendererComponent
  ],
  exports: [VirtualScrollRendererComponent, ItemsRendererComponent, CdkVirtualScrollRendererComponent, RenderingV2Module],
})
export class RenderingModule {}
